import { toArray } from 'lodash-es'

export const stringSplice = (str, i, count, insert) => {
  const arr = toArray(str)
  arr.splice(i, count, insert)
  return arr.join('')
}
